import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'
import { useNavigate } from 'react-router-dom'

import { useCart, useDispatchCart } from '../../Components/reducer/contextReducer';
export default function Cart() {
    const navigate = useNavigate()
    
    let data = useCart()
    let dispatch = useDispatchCart()

    let userEmail = localStorage.getItem("userEmail")

    const [address, setAddress] = useState(null)
    const [newAddress, setNewAddress] = useState({
        Address: ""
    })

    const handleAddress = () => {
        document.getElementById('checkOut').style.display = 'block'
        document.getElementById('sameAddress').style.display = 'none'
    }
    const handleAddNewAddress = () => {
        document.getElementById('newAddress').style.display = 'block'
    }

    const handleNewAddress = (e) => {
        e.preventDefault()
        fetch("http://localhost:8000/users/newAddress", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: userEmail,
                Address: newAddress.Address,
            })
        }).then((res) => res.json()).then((data) => {
            if (data !== null) {
                document.getElementById('checkOut').style.display = 'block'
                document.getElementById('sameAddress').style.display = 'none'
                document.getElementById('addr').innerText = newAddress.Address
            }
        })
    }

    fetch("http://localhost:8000/users/address", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: userEmail,
        })
    }).then((res) => res.json()).then((data) => setAddress(data));

    const handleChange = (e) => {
        e.preventDefault()
        setNewAddress({
            ...newAddress,
            [e.target.name]: e.target.value
        })
    }

    if (data.length === 0) {
        return (<div className='container text-center'>
            <Navbar/>
            <div>
                <div className='m-5 w-100 fs-3'>Cart is Empty!</div>
            </div>
            <div>
                <div className='m-5 w-100 '>
                    <Link className='btn btn-success' to='/medici'>Buy Some Medicines First</Link>
                </div>
            </div>
            <Footer/>
        </div>
)
    }
    let totalPrice = data.reduce((total, medItem) => total + parseInt(medItem.productAmount), 0)
    let originalProductAmount = data.map((item) => item.originalProductAmount);


    const handleCheckOut = () => {
        let response = fetch("http://localhost:8000/order/showOrders", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                order_data: data,
                email: userEmail,
                order_date: new Date(),
                delivered: 'no',
                paidStatus: 'pending',
                totalPrice: totalPrice,
                originalAmount: originalProductAmount,                
            })
        });
        if (response.status === 200) {
            dispatch({ type: "DROP" })
        }
        navigate('/userPayment')
    }


    return (
        <div className='container'>
            <Navbar/>

            <div className='container m-auto mt-5 table-responsive  table-responsive-sm table-responsive-md' >
                <table className='table table-hover '>
                    <thead className=' text-success fs-4'>
                        <tr>
                            <th scope='col' >#</th>
                            <th scope='col' >Image</th>
                            <th scope='col' >Title</th>
                            <th scope='col' >Type</th>
                            <th scope='col' >Quantity</th>
                            <th scope='col' >Amount</th>
                            <th scope='col' ></th>
                        </tr>
                    </thead>
                    <tbody>
                        {                                
                            data.map((medItem, index) => {
                            return(
                                    <tr key={index}>
                                        <th scope='row' >{index + 1}</th>
                                        <td ><img src={`http://localhost:8000/public/images/${medItem.productImage}`} width='40px' height='40px' alt="..." /></td>
                                        <td >{medItem.productTitle}</td>
                                        <td>{medItem.productType}</td>
                                    <td>{medItem.productCount} X {medItem.productQuantity}mg</td>                                    
                                    <td>₹{medItem.originalAmount}</td>
                                    <td >
                                        <button type="button" onClick={() => { dispatch({ type: "SINGLE_UPDATE", id: medItem.id }) }} className="btn btn-info ">+</button>
                                        <button type="button" onClick={() => { dispatch({ type: "SINGLE_REMOVE", id: medItem.id }) }} className="btn btn-info ">-</button>
                                    </td>                                    
                                        <td ><button type="button" onClick={() => { dispatch({ type: "REMOVE", index: index }) }} className="btn btn-warning ">-</button> </td>
                                    </tr>
                                )})
                        }
                    </tbody>
                </table>
                <div><h1 className='fs-2'>Total Price: ₹{totalPrice}/-</h1></div>
                <form id='checkOut' style={{display:'none'}} onSubmit={handleCheckOut} >
                    <button className='btn bg-success mt-5 'type='submit' >CheckOut</button>
                </form>
            </div>
            <div>
            </div>

            <div className='container'>
                <div className="card">
                    <div className="card-header">
                        Address
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">Current Address</h5>
                        <p id='addr' className="card-text">{address ? address : "No Address"}</p>

                        <button id='sameAddress' onClick={handleAddress} className="btn btn-primary">Continue With Same Address</button>
                        <br />
                        <br />
                        <button onClick={handleAddNewAddress} className="btn btn-primary">Add New Address</button>
                        <hr />
                        <div id='newAddress' style={{ display: 'none' }}>
                            <form onSubmit={handleNewAddress}>
                                <input name='Address' value={newAddress.Address} onChange={handleChange} className='form-input' />
                                <button className='btn btn-success' type='submit'>Update</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
<Footer/>
        </div>
    )
}
